<template>
    <div>
        <div v-if="isMultiple == false" class="with-absolute-button" id="multi-select-white">
            <multi-select  class="light-bg" v-model="localSelectedStructureUser" label="name" track-by="id"
                open-direction="bottom" :options="structureUsers" :searchable="true" :loading="loading"
                :internal-search="false" :clear-on-select="false" :close-on-select="true" :options-limit="300"
                :max-height="600" :show-no-results="false" :hide-selected="true" :multiple="false" @click="fixDropdownStyle"
                @search-change="getStructureUsers" @select="structureUserSelectChanged" @close="structureUsers = []"
                :allow-empty="clearable" ref="multiselect1" :disabled="disabled" :placeholder="$t('res_Label_SelectOption')">
                <template slot="clear">
                    <div v-if="clearable && !disabled && localSelectedStructureUser && localSelectedStructureUser.id != null"
                        class="structure-user-clear"
                        @mousedown.prevent.stop="clearSelection"></div>
                </template>
                <template slot="option" slot-scope="props">
                    <div style="height: 50px; width: 100%; display: flex;text-align:start">
                        <div class="" style="">
                            <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                        </div>
                        <div class="ad__box" v-if="props.option.isUser">
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                        <div class="ad__box" v-else>
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                    </div>
                </template>
                <template slot="noOptions" slot-scope="props">
                    <div style="text-align:start">
                        {{ $t("res_Msgs_EmptySearch") }}
                    </div>
                </template>
            </multi-select>
            <button :disabled="disabled" @click="openAddressBook">
                <v-icon class="float-right">mdi-user-add</v-icon> 
            </button>
        </div>

        <div id="multi-select-white" v-else class="with-absolute-button">
            <multi-select  id="multi-select-white" class="light-bg" v-model="localselectedStructureUsersList" label="name" track-by="id"
                :class="{ 'is--active': localselectedStructureUsersList.length > 0 }" open-direction="bottom"
                :options="structureUsers" :searchable="true" :loading="loading" :internal-search="false"
                :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                :show-no-results="false" :hide-selected="true" :multiple="true" @search-change="getStructureUsers"
                @input="structureUserSelectMultipleChanged" @close="structureUsers = []" :allow-empty="true"
                ref="multiselect1" :disabled="disabled" :placeholder="$t('res_Label_SelectOption')">
                <template slot="option" slot-scope="props">
                    <div style="width: 100%; display: flex;text-align:start; ">
                        <div class="" style="">
                            <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                        </div>
                        <div class="ad__box" v-if="props.option.isUser">
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                        <div class="ad__box" v-else>
                            <p class="ad__text__bold">{{ props.option.name }}</p>
                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                        </div>
                    </div>
                </template>
                <template slot="tag" slot-scope="{ option, remove }">
                    <span
                        class="multiselect__tag"
                        
                    >
                    <span :class="{ 'green-text': (option.external == false && option.isCompany == true) }">
                        {{ option.name }}
                    </span>
                        <i tabindex="2"
                        class="multiselect__tag-icon"
                        @click="remove(option)"
                        :class="{ 'green-text': (option.external == false && option.isCompany == true) }"
                        ></i>
                    </span>
                </template>
                <template slot="noOptions" slot-scope="props">
                    <div style="text-align:start">
                        {{ $t("res_Msgs_EmptySearch") }}
                    </div>
                </template>
            </multi-select>
            <button :disabled="disabled" @click="openAddressBook">
                <v-icon>mdi-user-add</v-icon>
            </button>
        </div>  
            <v-dialog v-model="addressBookDialog" content-class="dialog2 address-book-dialog with-fixed-actions">
                <div class="dialog-header" style="z-index: 3000 !important;">   
                    <h1 v-if="addressBook_header == ''">{{ $t('res_Label_Strucutres') }}</h1>
                    <h1 v-else>{{ addressBook_header }}</h1>
                </div>
                <div class="dialog-body white-container">
                    <address-book :showExternalUsers="showExternalUsers" :showInternalUsers="showInternalUsers"
                        :singleValue="addressBookDialog_Single" :reset="addressBookDialog_reset"
                        :showInternalStructures="addressBook_showInternalStructures" :adminForm="adminForm"
                        :showExternalStructures="addressBook_showExternalStructures" :defaultValue="addressBookDialog_ListValue"
                        :disableOtherInternalEntitiesAsExternal="disableOtherInternalEntitiesAsExternal"
                        @closeAddressBook="closeAddressBook" @handleSelectFromAddressBook="handleSelectFromAddressBook"
                        :allowStructureSelect="addressBookDialog_allowStructureSelect" :selectedStructureUser="localSelectedStructureUser" :selectedStructureUsersList="localselectedStructureUsersList"
                        :isForSignee="isForSignee" :excludeSelf="excludeSelf" :hideStructureWithDisableTransfer="hideStructureWithDisableTransfer"
                        :loadOnlyInScopeInternalStrucutres="loadOnlyInScopeInternalStrucutres" :loadOnlyInScopeInternalUsers="loadOnlyInScopeInternalUsers"
                        :categoryId="categoryId" :isSubscribedEntitiesEnable="isSubscribedEntitiesEnable"
                        :hideSubscribedCheckbox="hideSubscribedCheckbox" :showStructuresOnlyPerEntity="showStructuresOnlyPerEntity"
                        :companyId="companyId"></address-book>
                </div>
            </v-dialog>
    </div>
</template>

<script>
import constants from '@/assets/js/constants.js'
import MultiSelect from 'vue-multiselect'
import axios from 'axios';
import * as utils from '@/assets/js/common.js'
import AddressBook from '@/components/AddressBook.vue'
import { debounce } from 'lodash'

export default {
    name: 'StructureUserSelector',
    components: { MultiSelect, AddressBook },
    props: {
        adminForm : { type: Boolean, default: true },
        ignoreHideInTransfer: { type: Boolean, default: true },
        showInternalUsers: { type: Boolean, default: false },
        showExternalUsers: { type: Boolean, default: false },
        showInternalStructures: { type: Boolean, default: false },
        showExternalStructures: { type: Boolean, default: false },
        companyId: { type: Number, default: 0 },
        disableOtherInternalEntitiesAsExternal: { type: Boolean, default: false },
        isMultiple: { type: Boolean, default: false },
        clearable: { type: Boolean, default: true },
        selectedStructureUser: null,
        selectedStructureUsersList: null,
        dataToPassOnSelectChange: null,
        isForSignee: { type: Boolean, default: false },
        excludeSelf: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        addressBook_header: { type: String, default: '' },
        hideStructureWithDisableTransfer: { type: Boolean, default: false },
        loadOnlyInScopeInternalStrucutres: { type: Boolean, default: false },
        loadOnlyInScopeInternalUsers: { type: Boolean, default: false },
        acceptExternalEmails: { type: Boolean, default: false },
        fixDropdownStyle: { type: Function, default: () => { } },
        structure_id:{type:Number, default:0},
        categoryId: {type:Number, default:0},
        isSubscribedEntitiesEnable: { type: Boolean, default: false },
        hideSubscribedCheckbox: {type: Boolean, default: false},
        includeWorkflowParticipants: {type: Boolean, default: false},
        showStructuresOnlyPerEntity: { type: Boolean, default: false },
    },
    data() {
        return {
            lang: localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined ? localStorage.getItem('lang') : 'en',
            loading: false,
            structureUsers: [],
            addressBookDialog: false,
            addressBookDialog_Single: true,
            addressBookDialog_Title: '',
            addressBookDialog_ListValue: [],
            addressBookDialog_reset: 1,
            addressBookDialog_allowStructureSelect: false,
            addressBook_showInternalStructures: false,
            addressBook_showExternalStructures: false,
            localSelectedStructureUser: [],
            localselectedStructureUsersList: [],
            utils : utils,
            structureId:0,
        }
    },
    mounted() 
    {
        this.localSelectedStructureUser = this.selectedStructureUser;
        this.localselectedStructureUsersList = this.selectedStructureUsersList
        this.fixDropdownStyle();
    },
    watch:
    {
        selectedStructureUser(newVal) 
        {
            this.localSelectedStructureUser = newVal;
        },
        selectedStructureUsersList(newVal) 
        {
            this.localselectedStructureUsersList = newVal;
        },
        structure_id(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.structureId = newVal
            }
        },
    },
    methods: {  
        CapitalizeFirstLetter(str) 
        {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options) 
        {    
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        getStructureUsers(query) 
        {      
            this.debouncedGetStructureUsers(query);
        },
        debouncedGetStructureUsers: debounce(function(query) 
        {   
            if (query == '')
                return

            if (query != null && query != undefined)
                query = query.trim();
            
            this.structureUsers = []
            this.loading = true
            axios.get(constants.baseApiUrl + 'StructureUser/SearchWithAddressbook?' +
                'showInternalUsers=' + this.showInternalUsers +
                '&showExternalUsers=' + this.showExternalUsers +
                '&showInternalStructures=' + this.showInternalStructures +
                '&showExternalStructures=' + this.showExternalStructures +
                '&excludeSelf=' + this.excludeSelf +
                '&isForSignee=' + this.isForSignee +
                '&disableOtherInternalEntitiesAsExternal=' + this.disableOtherInternalEntitiesAsExternal +
                '&hideStructureWithDisableTransfer=' + this.hideStructureWithDisableTransfer +
                '&loadOnlyInScopeInternalStrucutres=' + this.loadOnlyInScopeInternalStrucutres +
                '&loadOnlyInScopeInternalUsers=' + this.loadOnlyInScopeInternalUsers +
                '&ignoreHideInTransfer=' + this.ignoreHideInTransfer + 
                '&structureId=' + this.structure_id +
                '&companyId=' + (this.companyId || 0) +
                '&showStructuresOnlyPerEntity=' + this.showStructuresOnlyPerEntity +
                '&search=' + encodeURIComponent(query))
                .then((res) => 
                {
                    this.structureUsers = res.data
                    if (this.includeWorkflowParticipants) {
                        const lowerQuery = (query || '').toLowerCase();
                        if ("all contributors".includes(lowerQuery) && !this.structureUsers.some(x => x.id === 'All Contributors')) {
                            this.structureUsers.push({ id: 'All Contributors', name: 'All Contributors' })
                        }
                        if ("cc/department".includes(lowerQuery) && !this.structureUsers.some(x => x.id === 'CC/Department')) {
                            this.structureUsers.push({ id: 'CC/Department', name: 'CC/Department' })
                        }
                        if ("recipient".includes(lowerQuery) && !this.structureUsers.some(x => x.id === 'recipient')) {
                            this.structureUsers.push({ id: 'recipient', name: 'recipient' })
                        }
                        if ("initiator".includes(lowerQuery) && !this.structureUsers.some(x => x.id === 'initiator')) {
                            this.structureUsers.push({ id: 'initiator', name: 'initiator' })
                        }
                        if ("secretary".includes(lowerQuery) && !this.structureUsers.some(x => x.id === 'Secretary')) {
                            this.structureUsers.push({ id: 'Secretary', name: 'Secretary' })
                        }
                    }
                    if (this.acceptExternalEmails)
                        this.handleAddEmail(query);
                })
                .catch((err) => console.warn(err))
                .finally(() => this.loading = false)
        }, 300),
        clearSelection() 
        {
            this.structureUserSelectChanged(null);
        },
        structureUserSelectChanged(item) 
        {        
            this.$set(this, 'localSelectedStructureUser', item);
            this.$emit('structureUserSelectChanged', item, this.dataToPassOnSelectChange);
            this.structureUsers = [];
        },
        structureUserSelectMultipleChanged(selectedItems)
        {          
            this.$set(this, 'localselectedStructureUsersList', selectedItems);
            this.$emit('structureUserSelectChanged', selectedItems);

            this.structureUsers = [];
        },
        openAddressBook() 
        {
            this.addressBookDialog_Single = !this.isMultiple;
            this.addressBookDialog_ListValue = [];

            this.addressBook_showInternalStructures = this.showInternalStructures || this.showInternalUsers;
            this.addressBook_showExternalStructures = this.showExternalStructures || this.showExternalUsers;

            if (this.showInternalStructures || this.showExternalStructures) {
                this.addressBookDialog_allowStructureSelect = true;
            } else {
                this.addressBookDialog_allowStructureSelect = false;
            }

            if (this.isMultiple) 
            {
                for (var i = 0; i < this.structureUsers.length; i++) 
                {
                    if (this.structureUsers[i].id != null) 
                    {
                        valuesList.push({
                            id: this.structureUsers[i].id,
                            name: this.structureUsers[i].name,
                            isUser: this.structureUsers[i].isUser
                        })
                    }
                }
            }

            this.addressBookDialog_reset = new Date().valueOf();
            this.addressBookDialog = true
        },
        closeAddressBook() 
        {
            this.addressBookDialog = false
        },
        handleSelectFromAddressBook(selectedItems) 
        {
            if(this.selectedStructureUser && this.selectedStructureUsersList && this.selectedStructureUser.length > 0 && this.selectedStructureUsersList.length > 0)
            {
                this.selectedStructureUser.forEach(element => {
                    var customElement = {
                        external: element.external, 
                        id: element.id, 
                        isUser: element.isUser, 
                        name: element.name,
                        email:element.email
                        };
                    if (customElement.id != null && !selectedItems.some(x => x.id == customElement.id)) {
                        selectedItems.push(customElement);   
                    }
                }); 
            }
               
            if (!this.isMultiple) 
            {
                this.structureUserSelectChanged(selectedItems);
            }
            else 
            {
                // if (this.selectedStructureUsersList.length > 1) {
                //     this.selectedStructureUsersList.forEach((item) => {
                //         if (item.id && !selectedItems.some(x => x.id == item.id)) {
                //             selectedItems.push(item);
                //         }
                //     });
                // }

                this.structureUserSelectMultipleChanged(selectedItems);
            }

            this.closeAddressBook()
        },
        handleAddEmail(value) 
        {
            if (!utils.isValidEmail(value)) 
                return;

            const existingEmail = this.structureUsers.find(user => user.id === value);
            if (!existingEmail) 
            {
                const randomId = Math.random().toString(36).substr(2, 9);
                this.structureUsers.push({ id: randomId, name: value, email: value });
            }
        }
    }
}
</script>

<style scoped>
#dwt-container {
    display: flex;
    height: inherit;
    width: inherit;
}

#dwt-control {
    max-width: 400px;
}

.multiselect__tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #eff2f5;
  border-radius: 12px;
  font-size: 13px;
  margin: 2px;
  line-height: 20px;
  white-space: nowrap;
}

/* Close (x) button */
.multiselect__tag-icon {
  font-style: normal;
  font-weight: bold;
  margin-left: 8px;
  cursor: pointer;
}

/* Custom text color for external == 0 */
.green-text {
  color: green;
}
</style>